//TODO DELETE THE OLD TRAIN CONNECTIVITY FROM APP-MENU DOT JSON
import { Component, OnDestroy, OnInit } from '@angular/core';
import { TrainConnectivity } from "../../models/train-connectivity";
import { TrainRemark } from "../../models/train-remark";
import { TrainConnectivityReportDataService } from "../../services/train-connectivity-report-data.service";
import { DatePipe } from '@angular/common'
import { switchMap, take } from "rxjs/operators";
import { BehaviorSubject, merge, Observable, of, Subscription } from "rxjs";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { FormValidationService } from "../../../../shared/services/form-validation.service";
import { StateService } from "@uirouter/core";
import { environment } from '../../../../../environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { TableStateService } from '../../../../shared/services/table-state.service';

type Period = { name: string; timeSlot: string }
type PeriodOption = { label: string; value: string; color: string }

@Component({
  selector: 'app-train-connectivity-report',
  template: require('./train-connectivity-report.component.html'),
  styles: [require('./train-connectivity-report.component.sass')]
})
export class TrainConnectivityReportComponent implements OnInit, OnDestroy {

  trainConnectivities$: Observable<TrainConnectivity[] | null>;
  trainRemarks$: Observable<TrainRemark[] | null>;
  projectId: number;
  selectedDate: string | null;

  periods: Period[] = environment.trainConnectivity.periods;
  options: PeriodOption[] = environment.trainConnectivity.periodOptions;
  
  selectedTab = 'status';
  
  today = new Date().getTime();
  yesterday: number;

  remarkEditEnabled: {[key: string]: boolean} = {};

  selectedOptionForAll: { [key: string]: PeriodOption };

  trainConnectivityColumns: any[];
  trainRemarkColumns: any[];

  private readonly refreshTrainConnectivitiesList$ = new BehaviorSubject(undefined);
  private readonly refreshTrainRemarkList$ = new BehaviorSubject(undefined);

  remarkForm: FormGroup; // TODO ADD REMARK FORM TO EDIT REMARK PROBLEM FOUND IN DIPLAY DATA

  languageChangeSubscription: Subscription;
  locale = environment.calendar.locales['en'];

  tableConfiguration: any ;

  showNewRemarkForm = false;

  trainConnectivityForm: FormGroup;

  constructor(
    private $state: StateService,
    private trainConnectivityReportDataService: TrainConnectivityReportDataService,
    private datePipe: DatePipe,
    private fb: FormBuilder,
    public formValidation: FormValidationService,
    private translate: TranslateService,
    private messageService: MessageService,
    public tableState: TableStateService
  ) {
    this.locale = environment.calendar.locales[this.translate.currentLang];
    this.projectId = this.$state.params && this.$state.params.projectId;
    this.selectedDate = (this.$state.params && this.$state.params.date) || (this.datePipe.transform(this.today, "yyyy-MM-dd"));

    this.trainConnectivities$ = this.refreshTrainConnectivitiesList$.pipe(
      switchMap(() => merge(
        of(null),
        this.trainConnectivityReportDataService.getTrainConnectivities(this.projectId, this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")),
      )
      ));

    this.trainRemarks$ = this.refreshTrainRemarkList$.pipe(
      switchMap(() => merge(
        of(null),
        this.trainConnectivityReportDataService.getTrainRemarks(this.projectId, this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'T'HH:mm:ssZ")))));


    // TODO ADD REMARK FORM TO EDIT REMARK PROBLEM FOUND IN DIPLAY DATA
    this.remarkForm = this.fb.group({
      trainRemarkId: [{ value: '', disabled: true }],
      trainid: ['', Validators.required],
      projectId: [this.projectId, Validators.required],
      comment: ['', Validators.required],
      date: [new Date(), Validators.required]
    })


  }

  ngOnInit(): void {
    this.tableConfiguration = {
      paginate: true,
      sortableMode: 'multiple',
      defaultPagination: 250,
      itemsPerPageOptions: [50,100,250,500],
      globalFilterFields: ['trainId', ...this.periods.map(period => period.name)],
      exportTrainConnectivityFilename: 'trainconnectivities-' + this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'"),
      exportTrainRemarkFilename: 'trainremarks-' + this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'")
    }

    this.selectedOptionForAll = this.periods.reduce((acc, period) => {
      acc[period.name] = period;
      return acc;
    }, {})
    this.yesterday = this.today - (24 * 60 * 60 * 1000);
    this.refreshTrainConnectivitiesList$.next(undefined);
    this.refreshTrainRemarkList$.next(undefined);
    this.refreshTables();

    this.trainConnectivityForm = this.fb.group({
      currentDate: [new Date(this.selectedDate || Date.now())]
    });

    this.languageChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.refreshTables();
      this.locale = environment.calendar.locales[this.translate.currentLang];
    })
  }

  refreshTables = () => {
    this.trainConnectivityColumns = [{
        header: this.translate.instant('I18N_TRAIN_CONNECTIVITY.TRAIN_ID'),
        field: 'trainId',
        type: 'text',
        width: '100px'
      }, 
    ...this.periods.map(period => {
      return {
        header: period.timeSlot,
        field: period.name,
        type: period.name
      }
    })]

    this.trainRemarkColumns = [{
      header: this.translate.instant('I18N_TRAIN_CONNECTIVITY.TRAIN_ID'),
      field: 'trainid',
      type: 'text',
      width: '100px'
    }, {
      header: this.translate.instant('I18N_TRAIN_CONNECTIVITY.COMMENTS'),
      field: 'comment',
      type: 'text',
    }, {
      header: this.translate.instant('I18N_GENERAL.ACTIONS'),
      disableSorting: true,
      disableSearch: true,
      field: 'actions',
      width: '200px'
    }]
  }

  showTrainConnectivity = (newDate: number | string) => {
    this.selectedDate = this.datePipe.transform(newDate, "yyyy-MM-dd")
    this.$state.go('train-connectivity', {
      projectId: this.projectId,
      date: this.selectedDate
    }, { reload: true })
  }

  changeTrainConnectivityPeriod = async (trainConnectivities: TrainConnectivity[], selectedPeriod: Period, selectedOption: PeriodOption) => {
    if (trainConnectivities.length > 0) {
      for (let i = 0; i < trainConnectivities.length; i++) {
        const trainConnectivity: TrainConnectivity = trainConnectivities[i];
        trainConnectivity[selectedPeriod.name] = selectedOption;
      }
      if (trainConnectivities.length > 1) {
        await this.trainConnectivityReportDataService.updateAllTrainsConnectivities(this.projectId, trainConnectivities, this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")).toPromise()
        this.refreshTrainConnectivitiesList$.next(undefined);
      } else {
        const trainConnectivity: TrainConnectivity = trainConnectivities[0];
        await this.trainConnectivityReportDataService.updateTrainConnectivity(this.projectId, trainConnectivity.trainConnectivityId, trainConnectivity, this.datePipe.transform(this.selectedDate, "yyyy-MM-dd'T'HH:mm:ssZZZZZ")).toPromise()
      }
    }
  }


  createRemark = async () => {
    if (this.remarkForm.valid) {
      try {
        await this.trainConnectivityReportDataService.addTrainRemark(this.projectId, this.remarkForm.value).toPromise();
        this.remarkForm.reset();
        this.showNewRemarkForm = false;
        this.messageService.add({
          severity:'success',
          summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.CREATE_REMARK"),
          detail: `${this.translate.instant("I18N_TRAIN_CONNECTIVITY.REMARK")} ${this.translate.instant("I18N_GENERAL.HAS_BEEN_SUCCESSFULLY_CREATED")} `
        });
        this.refreshTrainRemarkList$.next(undefined);
      } catch (error) {
        this.messageService.add({
          severity:'error',
          summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.ERROR_CREATE_REMARK"),
          detail:error.message
        });
      }
    }
    else {
      this.formValidation.validateAllFormFields(this.remarkForm);
    }
  }

  editRemark = async (remark: TrainRemark, i: number) => {
    try {
      await this.trainConnectivityReportDataService.updateTrainRemark(remark.projectId, remark.trainRemarkId, remark).toPromise()
      this.remarkEditEnabled[i] = false;
      this.messageService.add({
        severity:'success',
        summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.UPDATE_REMARK"),
        detail: `${this.translate.instant("I18N_TRAIN_CONNECTIVITY.REMARK")} ${this.translate.instant("I18N_GENERAL.HAS_BEEN_SUCCESSFULLY_UPDATED")} `
      });
      this.refreshTrainRemarkList$.next(undefined); 
    } catch (error) {
      this.messageService.add({
        severity:'error',
        summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.ERROR_EDIT_REMARK"),
        detail:error.message
      });
    }

  }

  deleteRemark = async (remark: TrainRemark) => {
    try {
      await this.trainConnectivityReportDataService.deleteTrainRemark(remark.trainRemarkId, remark.projectId).toPromise()
      this.messageService.add({
        severity:'success',
        summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.DELETE_REMARK"),
        detail: `${this.translate.instant("I18N_TRAIN_CONNECTIVITY.REMARK")} ${this.translate.instant("I18N_GENERAL.HAS_BEEN_SUCCESSFULLY_DELETED")} `
      });
      this.refreshTrainRemarkList$.next(undefined); 
    } catch (error) {
      this.messageService.add({
        severity:'error',
        summary: this.translate.instant("I18N_TRAIN_CONNECTIVITY.ERROR_DELETE_REMARK"),
        detail:error.message
      });
    }

  }

  ngOnDestroy() {
    if (this.languageChangeSubscription) {
      this.languageChangeSubscription.unsubscribe();
    }
  }
}
